import { privateApi } from '@/config/axios.config';
import {
  MaintenanceRequest,
  MaintenanceRequestCreateDTO,
  MaintenanceRequestUpdateDTO,
  MaintenanceRequestFilters,
  MaintenanceRequestStats,
} from '../types/maintenance-request.types';

const API_BASE = '/condominium/maintenance-requests';

export const maintenanceRequestsApiService = {
  // Obtener todas las solicitudes de mantenimiento con filtros
  async getMaintenanceRequests(filters: MaintenanceRequestFilters = {}): Promise<{
    requests: MaintenanceRequest[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }> {
    const params = new URLSearchParams();

    if (filters.status) params.append('status', filters.status);
    if (filters.priority) params.append('priority', filters.priority);
    if (filters.category) params.append('category', filters.category);
    if (filters.unitId) params.append('unitId', filters.unitId);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await privateApi.get(`${API_BASE}?${params.toString()}`);
    return response.data?.data || response.data;
  },

  // Obtener una solicitud de mantenimiento por ID
  async getMaintenanceRequestById(id: string): Promise<MaintenanceRequest> {
    const response = await privateApi.get(`${API_BASE}/${id}`);
    return response.data?.data || response.data;
  },

  // Obtener estadísticas de solicitudes de mantenimiento
  async getMaintenanceRequestStats(): Promise<MaintenanceRequestStats> {
    const response = await privateApi.get(`${API_BASE}/stats`);
    return response.data?.data || response.data;
  },

  // Crear nueva solicitud de mantenimiento
  async createMaintenanceRequest(
    data: MaintenanceRequestCreateDTO,
  ): Promise<MaintenanceRequest> {
    const response = await privateApi.post(`${API_BASE}`, data);
    return response.data?.data || response.data;
  },

  // Actualizar solicitud de mantenimiento
  async updateMaintenanceRequest(
    id: string,
    data: MaintenanceRequestUpdateDTO,
  ): Promise<MaintenanceRequest> {
    const response = await privateApi.put(`${API_BASE}/${id}`, data);
    return response.data?.data || response.data;
  },

  // Eliminar solicitud de mantenimiento (soft delete)
  async deleteMaintenanceRequest(id: string): Promise<void> {
    await privateApi.delete(`${API_BASE}/${id}`);
  },
};
